import { makeStyles } from '@material-ui/core'

export const useMalfunctionGroupsFieldStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--vel-fixed-spacing-03)',
  },
  checkboxCardGroup: {
    '& > div': {
      width: '100%',
      '& label': {
        width: '100%',
      },
    },
  },
  freeText: {
    marginBottom: 'var(--vel-fixed-spacing-03)',
  },
}))
